<script>
  import 'vue-strap/dist/vue-strap-lang';
  import converterMoeda from '~js/converter-moeda';

  export default {
    components: {  
    },
    props: {
      item: Object,
      index: Number = 0,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      descricaoItem(item) {
        let descricao = item.produto.nome;

        if (item.complementoItemPedido.length > 0)
          descricao += ' - ' + item.complementoItemPedido;

        return descricao;
      }
    },
    computed: {
      valorTotalItem() {
        const quantidade = this.$options.filters.formatarNumero(this.item.quantidade, true);
        const quantidadeCancelada = this.$options.filters.formatarNumero(this.item.quantidadeCancelada, true);
        const valorUnitario = this.$options.filters.formatarNumero(this.item.valorUnitario, true);
        const ipi = this.$options.filters.formatarNumero(this.item.ipiItemPedido, true);
        const desconto = this.$options.filters.formatarNumero(this.item.descontoDinheiro, true);

        let valor = ((quantidade - quantidadeCancelada) * valorUnitario);

        valor += (valor * ipi / 100);

        valor -= desconto;

        return converterMoeda.paraReal(valor);
      },
      localAlocado() {
        return '';

        let auxItem = this.item.itemCompra.itemSolicitacaoCompra;

        if (auxItem.localAlocado) {
          return auxItem.localAlocado; 
        }

        if (auxItem.enderecoLocalAlocado) {
          let auxLocal = auxItem.enderecoLocalAlocado;

          auxLocal += ', ' + auxItem.numeroLocalAlocado;

          auxLocal += ' - ' + auxItem.complementoLocalAlocado;

          auxLocal += ' - ' + auxItem.bairroLocalAlocado;

          auxLocal += ', ' + auxItem.cidadeLocalAlocado + ' ' + auxItem.estadoLocalAlocado;

          auxLocal += ' - ' + auxItem.cepLocalAlocado;

          auxLocal += ' (' + auxItem.unidadeLocalAlocado + ' - ' + auxItem.cnpjUnidadeLocalAlocado + ')';

          return auxLocal;
        }

        return '';        
      }
    }
  }
</script>

<template>
  <div>    
      <h4>
        Item #{{ index + 1 }}
      </h4>

      <dl v-if="item.itemCompra.projetoMetaEtapa !== null">
        <dt>Meta etapa</dt>
        <dd>{{ `${item.itemCompra.projetoMetaEtapa.meta.nome} - ${item.itemCompra.projetoMetaEtapa.etapa.nome}` }}</dd>
      </dl>

      <div class="row">
        <dl class="col-xs-6">
          <dt>Rubrica</dt>
          <dd>{{ item.itemCompra.rubrica.nome }}</dd>
        </dl>

        <dl class="col-xs-6">
          <dt>Subrubrica</dt>
          <dd>{{ item.itemCompra.subrubrica.nome }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-xs-8">
          <dt>Descri&ccedil;&atilde;o do material/servi&ccedil;o</dt>
          <dd class="white-space-pre">{{ descricaoItem(item) }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-xs-2">
          <dt>Quantidade</dt>
          <dd>{{ item.quantidade || '---' }}</dd>
        </dl>

        <dl class="col-xs-2">
          <dt>Quantidade cancelada</dt>
          <dd>{{ item.quantidadeCancelada || '---' }}</dd>
        </dl>

        <dl class="col-xs-2">
          <dt>Valor unit&aacute;rio</dt>
          <dd>{{ item.valorUnitario ? `R$ ${item.valorUnitario}` : '---' }}</dd>
        </dl>

        <dl class="col-xs-2">
          <dt>IPI</dt>
          <dd>{{ item.ipiItemPedido ? `${item.ipiItemPedido} %` : '---' }}</dd>
        </dl>

        <dl class="col-xs-2">
          <dt>Desconto</dt>
          <dd>{{ item.descontoDinheiro ? `R$ ${item.descontoDinheiro}` : '---' }}</dd>
        </dl>

        <dl class="col-xs-2">
          <dt>Total</dt>
          <dd>{{ valorTotalItem ? `R$ ${valorTotalItem}` : '---' }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-xs-8">
          <dt>Local que o material ser&aacute; alocado</dt>
          <dd class="white-space-pre">{{ localAlocado }}</dd>
        </dl>
      </div>
     
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pedidos-compras/componentes/compartilhado/FormListaItens.vue